import { Link } from '.'
import clsx from 'clsx'
import { css, useTheme } from '@emotion/react'
import { forwardRef } from 'react'

const Button = forwardRef(
    (
        {
            icon,
            href,
            children,
            target,
            onClick,
            download,
            type,
            color,
            external = true,
            hoverColor,
            size,
            className,
            disabled = false,
            backgroundColor,
            style,
            ...props
        },
        ref
    ) => {
        const theme = useTheme()

        const buttonSize = (bSize) => {
            switch (bSize) {
                case 'x-small':
                    return `
                    font-size: ${theme.fontSize.xs};
                    padding: ${theme.spacing.one};
                `
                case 'small':
                    return `
                    font-size: ${theme.fontSize.sm};
                    padding: ${theme.spacing.one};
                `
                case 'medium':
                    return `font-size: ${theme.fontSize.base}; ${
                        type === 'link'
                            ? `padding: ${theme.spacing.two};`
                            : `padding: ${theme.spacing.one} ${theme.spacing.two};`
                    };
                    `
                case 'large':
                    return `font-size: ${theme.fontSize.lg}; ${
                        type === 'link'
                            ? `padding: ${theme.spacing.three};`
                            : `padding: ${theme.spacing.four} ${theme.spacing.five};`
                    };`
                default:
                    return `font-size: ${theme.fontSize.base}; ${
                        type === 'link'
                            ? `padding: ${theme.spacing.two};`
                            : `padding: ${theme.spacing.one} ${theme.spacing.two};`
                    };
            
                    `
            }
        }
        const bStyle = `
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: ${theme.borderRadius.default};
            ${buttonSize(size)}
            background-color: ${theme.colors[backgroundColor]};
            color: ${theme.colors[color]};
            outline: 0;
            box-shadow: 0 0 0 0.2rem rgb(149 163 255 / 25%);
            &:hover {
                box-shadow: 0 0 0 0.2rem rgb(149 163 255 / 50%);
                background-color: ${theme.colors[hoverColor]};
                filter: contrast(120%);
            }
            ${
                disabled &&
                `filter: contrast(40%); &:hover {
                    box-shadow: none;
                    filter: contrast(40%);
                }`
            };
            ${style};
        `
        const buttonStyle = css`
            ${bStyle}
        `
        const sharedProps = {
            href,
            disabled,
            onClick
        }
        const linkBody = (
            <>
                {children && <span className="mx-1">{children}</span>}
                {icon && <span className="mx-1">{icon}</span>}
            </>
        )

        if (type === 'link')
            return (
                <Link
                    {...sharedProps}
                    external={external}
                    hoverColor={hoverColor}
                    className={clsx('', className, buttonSize(size))}
                    ref={ref}
                    {...props}
                >
                    {linkBody}
                </Link>
            )
        if (type === 'linkButton')
            return (
                <Link
                    {...sharedProps}
                    external={external}
                    className={clsx('link-button', className)}
                    style={bStyle}
                    download={download}
                    target={target}
                    backgroundColor={backgroundColor}
                    color={color}
                    ref={ref}
                    {...props}
                >
                    {linkBody}
                </Link>
            )
        if (type === 'submit')
            return (
                <input
                    {...sharedProps}
                    className={clsx('submit cursor-pointer', className)}
                    css={buttonStyle}
                    value={children}
                    type="submit"
                    ref={ref}
                    {...props}
                />
            )
        //{clsx('link inline-block', className)}
        return (
            <button
                {...sharedProps}
                className={clsx('button', className)}
                css={buttonStyle}
                ref={ref}
                {...props}
            >
                {linkBody}
            </button>
        )
    }
)

export default Button
